import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "heart-colorful--full--hover",
  "use": "heart-colorful--full--hover-usage",
  "viewBox": "0 0 18 16",
  "content": "<symbol viewBox=\"0 0 18 16\" id=\"heart-colorful--full--hover\"><linearGradient id=\"heart-colorful--full--hover_a\" gradientUnits=\"userSpaceOnUse\" x1=\"-13.205\" y1=\"26.77\" x2=\"18.96\" y2=\"-4.95\"><stop offset=\"0\" stop-color=\"#fce38a\" /><stop offset=\"1\" stop-color=\"#f38181\" /></linearGradient><path fill=\"url(#heart-colorful--full--hover_a)\" d=\"M9 3c-.67-1.732-2.547-3-4.5-3C1.957 0 0 1.932 0 4.5 0 8.029 3.793 10.758 9 16c5.207-5.242 9-7.971 9-11.5C18 1.932 16.043 0 13.5 0 11.545 0 9.67 1.268 9 3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/heart-colorful--full--hover.svg
// module id = 164
// module chunks = 0